<template>
  <div id="realTimeMap">
    <v-container fluid class="overrideContainer">
      <v-row>
        <v-overlay :value="showLoading">
      <v-progress-circular
        indeterminate
        size="64"
        color="white"
      ></v-progress-circular>
    </v-overlay>
        <v-col cols="12" sm="12" md="9" lg="9" class="overrideCol">
          <v-responsive :height="mapHeight">
            <div class="mapWrapper">
              <template v-if="mapType !== null">
                <LeafletRealTimeMapComponent :height="mapHeight" v-if="mapType == 0" />
                <GoogleRealTimeMapComponent  :height="mapHeight" v-if="mapType == 1" />
              </template>
              <!-- Dialog -->
              
              <PoiList
              v-if="tenant.usePoiPopUp && !mobileBereakPoint" />

              <v-dialog
                v-model="dialog.show"
                @keydown.esc="onCloseDialogHandler"
                max-width="380"
              >
                <template v-if="dialog.show">
                  <v-card flat tile>
                    <BaseDialogTitle @close="onCloseDialogHandler">
                      <template v-slot:title>{{ labels.poiDetails }}</template>
                    </BaseDialogTitle>
                    <v-card-text>
                      <MapCrudComponent
                        :mapType="mapType"
                        :mapData="mapCrudData"
                        @closeMapCrudComponent="handleMapCrudComponentClose"
                        :submited="dialog.submited"
                        :closed="!dialog.show"
                        @resetSubmit="dialog.submited = false"
                      ></MapCrudComponent>
                    </v-card-text>
                    <v-card-actions>
                      <SubmitGroup
                        @close="onCloseDialogHandler"
                        :closeOnSubmit="closeOnSubmit"
                        @submit="onSubmitDialogHandler"
                      />
                    </v-card-actions>
                  </v-card>
                </template>
              </v-dialog>
            </div>
          </v-responsive>
          
              <PoiList
              v-if="tenant.usePoiPopUp && mobileBereakPoint" />

        </v-col>
        <v-col cols="12" md="3" lg="3" class="overrideContainer">
          <RealTimeMapFiltersComponent :mobileBreakPoint="mobileBereakPoint" />

          <div v-if="showPoiLogicSyncNotification" class="pa-3">
            <v-alert color="warning" dark>
              <v-row no-gutters>
                <v-col class="text-caption font-weight-light">{{ $t('vehiclesPoiSyncInProgress') }}</v-col>
              </v-row>
            </v-alert>
          </div>

        </v-col>
      </v-row>

    </v-container>
  </div>
</template>

<script>
import BaseMapComponent from '../BaseMapComponent'
import EventBus from '../../../event-bus'
import store from '@/store/store'
import translate from '@/utils/genTable/multilanguageHelper.js'
import mapMixin from '../mapMixin.js'
import LeafletRealTimeMapComponent from './LeafletRealTimeMapComponent.vue'

export default {
  name: 'BaseRealTimeMapComponent',
  extends: BaseMapComponent,
  components: {
    LeafletRealTimeMapComponent,
    GoogleRealTimeMapComponent: () => import('./GoogleRealTimeMapComponent'),
    RealTimeMapFiltersComponent: () => import('./RealTimeMapFiltersComponent'),
    MapCrudComponent: () => import('../../map/MapCrudComponent'),
    SubmitGroup: () => import('@/components/SubmitGroup'),
    BaseDialogTitle: () => import('@/components/BaseDialogTitle'),
    PoiList: () => import('../PoiList')
  },
  mixins: [mapMixin],
  data() {
    return {
      showMapCrud: false,
      dialog: {
        show: false,
        component: this.MapCrudComponent,
        loading: true,
        submited: false
      },
      mapCrudData: {},
      closeOnSubmit: false,
      labels: {
        poiDetails: translate('POI details', 'maps')
      },
      mobileDisplayRatio: 2
    }
  },
  mounted() {
    this.init()
    EventBus.$on('DRAW_CIRCLE_POI', this.drawCirclePoi)
  },
  methods: {
    drawCirclePoi(data) {
      this.mapCrudData = data
      this.dialog.show = true
    },
    handleMapCrudComponentClose(notification) {
      this.mapCrudData = {}
      store.dispatch('notification/add', notification, { root: true })
      this.dialog.submited = false
      this.dialog.show = false
    },
    onCloseDialogHandler() {
      this.dialog.show = false
    },
    onSubmitDialogHandler() {
      this.dialog.submited = true
    }
  },
  computed: {
    mobileBereakPoint: function() {
      return this.$vuetify.breakpoint.smAndDown
    },
    mapHeight: function() {
      const displayHeight = this.$vuetify.breakpoint.height

      return this.mobileBereakPoint
        ? displayHeight / this.mobileDisplayRatio
        : 'auto'
    }
  }
}
</script>

<style scoped>
#realTimeMap {
  height: 86.6vh;
}

.mapWrapper {
  height: 93.4vh;
}

.overrideContainer {
  padding: 0px !important;
}

.overrideCol {
  padding: 0px !important;
}
</style>
